import { Injectable } from '@angular/core';
import { NavigationCancel, Router } from '@angular/router';
import { CarProvidersAuthService } from './auth.service';

@Injectable()
export class AuthGuardService {
  constructor(private auth: CarProvidersAuthService, private router: Router) { }

  canActivate() {
    if (this.auth.isAuthenticated()) {
      return true;
    }
    this.router.events.subscribe((ev: any) => {
      if (ev instanceof NavigationCancel) {
        const url = ev.url.includes('/home/') ? ev.url : `/home/${ev.url}`;
        localStorage.setItem('mainComponentToRedirectTo', `${url}`);
      }
    });
    this.router.navigate(['/login']);
    return false;
  }
}